import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './PrivacyPolicyPage.module.css';
import contactStyles from './ContactPage.module.css';

const SUPPORT_EMAIL = 'support@getautochef.com';
const MAILTO_HREF = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('AutoChef support request')}`;

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      <nav className={styles.nav}>
        <div className={styles.navContent}>
          <Link to="/" className={styles.logo}>
            <img src="/icons/autochef_logo.svg" alt="AutoChef" />
            <span>AutoChef</span>
          </Link>
          <div className={styles.navButtons}>
            <Link to="/signup" className={styles.navButton}>Start Free Trial</Link>
            <Link to="/login" className={styles.navButtonOutline}>Login</Link>
          </div>
        </div>
      </nav>

      <main className={styles.main}>
        <div className={styles.policyContainer}>
          <h1 style={{ marginTop: 0, marginBottom: '1rem', color: '#243029', fontSize: '1.75rem' }}>
            Contact &amp; support
          </h1>
          <p style={{ color: '#4a5568', lineHeight: 1.6, marginBottom: '1.25rem' }}>
            We&apos;re here to help with account questions, billing, bugs, and feedback. Send us an email
            and we&apos;ll get back to you as soon as we can.
          </p>
          <p style={{ color: '#4a5568', lineHeight: 1.6, marginBottom: '1.5rem' }}>
            <strong>Email:</strong>{' '}
            <a href={MAILTO_HREF} style={{ color: '#52cd92', fontWeight: 600 }}>
              {SUPPORT_EMAIL}
            </a>
          </p>
          <a href={MAILTO_HREF} className={contactStyles.emailSupportButton}>
            Email support
          </a>
          <p style={{ color: '#718096', fontSize: '0.9rem', marginTop: '1.75rem', marginBottom: 0 }}>
            If your email app doesn&apos;t open, copy the address above into your mail client.
          </p>
        </div>
      </main>

      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <div className={styles.footerBrand}>
            <img src="/icons/autochef_logo.svg" alt="AutoChef" />
            <span>AutoChef</span>
          </div>
          <div className={styles.footerLinks}>
            <Link to="/">Home</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
          <div className={styles.footerCopy}>
            © {new Date().getFullYear()} AutoChef. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
